import React from 'react';
import './index.css';
import { Image } from 'react-bootstrap';
import { ThreeDots } from 'react-loader-spinner';

const SplashScreen = () => {
  return (
    <div className='splash-wrapper'>
      <div>
        <Image src="/images/logo/colored-estate.png" alt='on9estate-logo' height={60} />
        <div className='position-relative d-flex align-items-center justify-content-center mt-5'>
          <div className='spinner'></div>
        </div>
      </div>
    </div>
  );
}

export default SplashScreen;
